<template>
  <div id="app">
    <div class="container-fluid">
      <div class="row d-flex d-md-block flex-nowrap wrapper">
        <MenuBar ref="MenuBox" />

        <div
          id="main"
          class="panel float-left p-0 content-map"
          style="position: fixed; width: 100%;"
        >
          <TopBar
            ref="TopBox"
            v-bind:class="[{'d-none': map_fullscreen || $route.name == 'MapTripListAlt'}]"
          />

          <div
            class="content p-4"
            style="padding-top: 60px !important;"
            v-bind:class="[{'d-none':!isOffline}]"
          >
            <img
              class="m-auto"
              height="75"
              :src="problem_connect_icon"
            >
            <div class="error-msg mt-4">
              {{ problem_connect_msg }}
            </div>
          </div>

          <LatestNews
            v-if="isDesktop() && !isHideMap && $route.name != 'MapTripListAlt'"
            :isDesktop="isDesktop()"
            :class="[{'d-none': map_fullscreen}]"
          />

          <Map
            ref="MapBox"
            :fullscreen="map_fullscreen"
            v-bind:class="[{'d-none': $route.name == 'Privacy' || (isHideMap && !isDesktop() && ($route.name == 'SearchRoute' || $route.name == 'Bus' || $route.name == 'Search') || (disableMapPage.includes($route.name) || isOffline))}]"
          />

          <router-view
            v-bind:class="[{'d-none':(isOffline || map_fullscreen)}]"
            ref="ContentBox"
          >
          </router-view>
        </div>
      </div>
    </div>
    <app-promotional-modal />
  </div>
</template>

<script>
import TopBar from '@/components/TopBar';
import MenuBar from '@/components/MenuBar';
import LatestNews from '@/components/LatestNews';
import Map from '@/components/Map';
import AppPromotionalModal from '@/components/Modal/AppPromotionalModal.vue';

import { mapGetters, mapActions } from 'vuex'
var MobileDetect = require('mobile-detect')
var md = new MobileDetect(window.navigator.userAgent)

require('@/scripts/utils.js');

export default {
  name: 'App',
  components: {
    TopBar,
    MenuBar,
    Map,
    LatestNews,
    AppPromotionalModal
  },
  computed: {
    ...mapGetters({
      showLoader: 'loading/getLoading',
      showContentDetails: 'content/getContent',
      isNoLogin: 'noLogin/getNoLogin',
    }),
  },
  data () {
    return {
      map: null,
      initialMapLanguage: null,
      initialMapLayer: null,
      is_login: false,
      access_token: null,
      active: false,
      selectedSearch: '',
      search_results: null,
      fullname: '',
      email: '',
      profile_picture: '',
      isHideSearch: false,
      isHideMap: false,
      isOffline: false,
      slideout: null,
      bottom_height: 0,
      api_url: process.env.API_URL + '/',
      default_location: { lat: 13.764953, lon: 100.538316 },
      resizeDebounceTimer: null,
      icon: {
        expand_icon: require('@/assets/icon/ic_more_white.png'),
        less_icon: require('@/assets/icon/ic_less_white.png'),
        loading_icon: require('@/assets/ic_loading.png'),
        reloading_icon: require('@/assets/icon/ic_reload_white.png'),
        arrow_down_icon: require('@/assets/icon/arrow.png'),
        arrow_down_icon_alt: require('@/assets/icon/arrow_alt.svg'),
        pin_icon: require('@/assets/icon/ic_pin.svg'),
        pin_white_icon: require('@/assets/icon/ic_pin_white.svg'),
        walk_icon: require('@/assets/icon/ic_walk_white.svg'),
        walk_icon_primary: require('@/assets/icon/ic_walk.svg'),
        walk_icon_gray: require('@/assets/icon/ic_walk_gray.svg'),
        time_icon: require('@/assets/icon/ic_time.png'),
        time_gray_icon: require('@/assets/icon/ic_time_gray.png'),
        announce_icon: require('@/assets/icon/ic_announce_white.png'),
        share_icon: require('@/assets/icon/ic_share.svg'),
        route_current_icon: require('@/assets/icon/ic_route_current.png'),
        stop_overlay_icon: require('@/assets/icon/ic_stop_overlay.svg'),
        current_location_icon: require('@/assets/icon/ic_current_location.svg'),
        gps_icon: require('@/assets/icon/ic_gps.svg'),
        pin_destination: require('@/assets/ic_pin_go.png'),
        navi_icon: require('@/assets/icon/ic_navigation_wh.png'),
        navi_icon_accent: require('@/assets/icon/ic_navigation_accent.png'),
        bus_icon: require('@/assets/icon/ic_bus_white.png'),
        bus_icon_blue: require('@/assets/icon/ic_bus_blue.svg'),
        fav_icon: require('@/assets/icon/ic_fav_white.png'),
        landmark_icon: require('@/assets/icon/ic_official_white.png'),
        traffic_icon: require('@/assets/icon/ic_traffic_white.png'),
        event_icon: require('@/assets/icon/ic_announce_copy_white.png'),
        news_icon: require('@/assets/icon/ic_news.svg'),
        setting_icon: require('@/assets/icon/ic_setting_white.png'),
        language_icon: require('@/assets/icon/ic_language_white.png'),
        support_icon: require('@/assets/icon/ic_support_white.svg'),
        feedback_icon: require('@/assets/icon/ic_feedback_white.png'),
        open_data_icon: require('@/assets/icon/ic_open_data_white.svg'),
        info_icon: require('@/assets/icon/ic_info_white.svg'),
        privacy_icon: require('@/assets/icon/ic_privacy_white.png'),
        logout_icon: require('@/assets/icon/ic_logout_white.png'),
        user_icon: require('@/assets/user.png'),
        search_icon: require('@/assets/icon/ic_search.svg'),
        search_icon_gray: require('@/assets/icon/ic_search_gray.svg'),
        directions_icon: require('@/assets/icon/ic_directions.svg'),
        menu_icon: require('@/assets/icon/ic_hamburger_white.svg'),
        close_icon: require('@/assets/icon/ic_close.svg'),
        pin_my_location: require('@/assets/ic_current_location.png'),
        from_pin: require('@/assets/icon/ic_pin_from.png'),
        to_pin: require('@/assets/icon/ic_pin_to.png'),
        taxi_icon: require('@/assets/icon/ic_taxi.svg'),
        current_accent_icon: require('@/assets/icon/ic_current_accent.svg'),
        start_icon: require('@/assets/icon/ic_start.svg'),
        destination_icon: require('@/assets/icon/ic_pin_white.svg'),
        pin_fav: require('@/assets/icon/ic_pin_fav.png'),
        back_icon: require('@/assets/icon/ic_back_white.png'),
        back_alt_icon: require('@/assets/icon/ic_back_alt_white.png'),
        search_route_chevron: require('@/assets/icon/search_route_chevron.svg'),
        map_marker_icon: require('@/assets/icon/ic_map_marker.svg'),
        wait_icon: require('@/assets/icon/ic_wait.svg'),
        three_dots_icon: require('@/assets/icon/ic_three_dots.svg')
      },
      problem_connect_icon: require('@/assets/ic_connect.png'),
      problem_connect_msg: 'การเชื่อมต่อมีปัญหา',
      problem_error_icon: require('@/assets/ic_error.png'),
      problem_error_msg: 'มีบางอย่างผิดปกติ กรุณาลองใหม่อีกครั้ง',
      currentLocation: null,
      alertFlag: false,
      search_routing: {},
      config: {
        uiLocale: null,
        mapLocale: null,
        map: window.longdo ? window.longdo.Layers.TRAFFIC.name() : 'map',
        maxWalk: 1000,
        wheelchair: false,
      },
      disableMapPage: ['Login', 'FacebookLogin', 'LineLogin', 'Logout', 'Settings', 'About', 'Support', 'Opendata', 'News', 'Privacy', 'AppRedirect', 'MapTripListAlt'],
      lastLocation: null,
      favorite_results: [],
      stop_favorite_results: [],
      event_results: [],
      tag_results: [],
      is_desktop: this.isDesktop(),
      event_selected: false,
      map_fullscreen: false,
    }
  },
  watch: {
    $route (to, from) {
      if (from.name === null && !['SharedRoute', 'MapTripList', 'MapTripListDebug', 'MapTripListAlt', 'BusTrip', 'BusTripDebug', 'Privacy', 'FacebookLogin', 'LineLogin', 'AppRedirect'].includes(to.name)) {
        this.$router.replace({ name: 'Home' })
        return
      }
      if (to.name == 'LineLogin' || to.name == 'FacebookLogin' || ((to.name == 'SearchRoute') && !this.isDesktop())) {
        this.isHideSearch = true
      } else {
        this.isHideSearch = false
      }

      if (to.name == 'Home' || to.name == 'Favorites' || to.name == 'Landmarks' || to.name == 'Events' || to.name == 'Announce') {
        this.search_routing = {}
      }

      if ((from.name == 'Home' && to.name == 'SearchRoute') || (from.name == 'Home' && to.name == 'SearchRoute')) {
        this.search_routing = {}
      }

      if (to.name != 'Events') {
        this.event_selected = false
      }
    },
    stop_favorite_results () {
      const pinRoutes = ['Home', 'MapTripList', 'MapTripListDebug']
      if (pinRoutes.includes(this.$route.name)) {
        this.pinStopFavorite()
      }
    },
    showContents: function (val) {
      this.matchHeight()
    },
    is_login: function (val) {
      if (val == false) {
        this.fullname = ''
        this.email = ''
        this.profile_picture = ''
      }
    }
  },
  created () {
    console.log('created facebook sdk')

    var app_id = process.env.FB_API_KEY

    window.fbAsyncInit = function () {
      FB.init({
        appId: app_id,
        cookie: true,
        xfbml: true,
        version: 'v2.11',
        status: true, // check login status
      });
      FB.AppEvents.logPageView();
    };

    (function (d, s, id) {
      var js, fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) { return; }
      js = d.createElement(s); js.id = id;
      js.src = "//connect.facebook.net/en_US/sdk.js";
      if (fjs && fjs.parentNode) fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'facebook-jssdk'));

    this.getConfig()
  },
  async mounted () {
    let scope = this

    window.addEventListener('resize', function () {
      scope.resize()
    })

    window.addEventListener('orientationchange', function () {
      scope.resize()
    }, false)

    document.addEventListener('gesturestart', function (e) {
      e.preventDefault()
    })

    window.addEventListener('online', function () {
      scope.isOffline = false
    })
    window.addEventListener('offline', function () {
      scope.isOffline = true
    })

    scope.resize()

    await this.isLogin()

    // scope.getTags()
    // scope.getEvents()
    scope.getFavorites()

    if (this.isDesktop()) {
      this.showContent()
    }
  },
  updated: function () {
    if (this.isDesktop()) {
      this.showContent()
    }

    this.resize()
    if (this.map != null) this.map.Ui.Fullscreen.visible(this.is_desktop)
  },
  methods: {
    ...mapActions({
      showContent: 'content/showContent',
      hideContent: 'content/hideContent',
    }),
    async isLogin () {
      var access_token = localStorage.getItem('access_token')
      var refresh_token = localStorage.getItem('refresh_token')

      if (access_token == undefined || access_token == null || refresh_token == undefined || refresh_token == null) {
        console.log('No Login')
        this.is_login = false
      } else {
        await this.refreshToken(refresh_token)
      }
    },
    async refreshToken (token) {
      var url = process.env.API_URL + '/authen/token'

      const data = {
        'refresh_token': token,
        'grant_type': 'refresh_token',
      }

      const apiResult = await this.Api.Call({
        method: 'POST',
        path: url,
        data: data,
      });

      this.is_login = apiResult.status === 200

      if (this.is_login) {
        localStorage.setItem('access_token', apiResult.data.access_token)
        localStorage.setItem('refresh_token', apiResult.data.refresh_token)
        this.access_token = apiResult.data.access_token
        this.refresh_token = apiResult.data.refresh_token
        this.fullname = localStorage.getItem('fullname')
        this.profile_picture = localStorage.getItem('profile_picture')
        this.getConfig()
      } else {
        localStorage.removeItem('access_token')
        localStorage.removeItem('refresh_token')
      }
    },
    goToFavoritePlace (favorite) {
      favorite.lat = favorite.location.lat
      favorite.lon = favorite.location.lon
      this.$router.push({
        name: 'Place',
        params: { data: favorite, isFavorite: true }
      })
    },
    goToStop (stationId) {
      this.$router.push({
        name: 'MapTripList',
        params: { stationId }
      })
    },
    isDesktop () {
      return (window.innerWidth && window.innerWidth >= 1024)
    },
    swapContent () {
      if (this.isDesktop()) return

      if (this.showContentDetails) {
        this.hideContent()
      } else {
        this.showContent()
      }
    },
    openSlide (eve) {
      if (eve != null) {
        eve.stopPropagation()
        eve.preventDefault()
      }
      this.active = true
    },
    close (eve) {
      if (eve != null) {
        eve.stopPropagation()
        eve.preventDefault()
      }
      this.active = false
    },
    closeWithPropagation () {
      this.active = false
    },
    async apiLogin (provider, id, token) {
      var url = process.env.API_URL + '/authen/social'
      const data = {
        'user_id': id,
        'access_token': token,
        'provider': provider
      }

      const apiResult = await this.Api.Call({
        method: 'POST',
        path: url,
        data: data,
      });

      return apiResult
    },
    async getConfig () {
      let config = null
      // get config from network or localStorage
      if (this.is_login) {
        // WS-114
        var url = process.env.API_URL + '/front/user/config/get'

        const apiResult = await this.Api.Call({
          method: 'GET',
          path: url,
        });

        if (apiResult.code === 200) {
          config = apiResult.data
        }
      } else {
        config = localStorage.getItem('settings') ? JSON.parse(localStorage.getItem('settings')) : null
      }
      // apply config
      if (config != null && config != undefined) {
        this.config.uiLocale = config.uiLocale || null
        this.config.mapLocale = config.mapLocale || null
        this.config.maxWalk = config.maxWalk || 1000
        this.config.wheelchair = config.wheelchair || false
        this.config.map = config.map || null
      }
      this.$i18n.locale = this.config.uiLocale

      var language = window.navigator.userLanguage || window.navigator.language;
      console.log(language); //works IE/SAFARI/CHROME/FF
      language = language.substring(0, 2)

      if (this.config.uiLocale == null) this.$i18n.locale = language
      if (this.map != null) {
        this.configMap(this.map)
      } else {
        this.initialMapLanguage = language
        this.initialMapLayer = this.config?.map || null
      }
      // finish apply config

      // this.axios.defaults.params['locale'] = this.$i18n != null ? this.$i18n.locale : 'th'

      this.getTags()
      this.getEvents()
    },
    mapInit (isNew = false) {
      let scope = this

      if (this.map == null || isNew) {
        longdo.MapTheme.ui.geolocationMarkerIcon = { urlHD: scope.icon.pin_my_location, offset: { x: 28, y: 41 } }

        var mmmap = new longdo.Map({
          layer: [
            longdo.Layers.LIGHT_POI,
            // longdo.Layers.TRAFFIC
          ],
          zoom: 17,
          zoomRange: { min: 5, max: 20 },
          location: scope.default_location,
          placeholder: document.getElementById('map'),
        })
        mmmap.Layers.externalOptions({ googleQuery: 'key=AIzaSyD6fc4hadKitwB8hZxEu7n7L6fKS474n28' })

        mmmap.Event.bind('fullscreen', function (val) {
          scope.map_fullscreen = val
        })
        mmmap.Event.bind('click', function (val) {
          const overlayList = mmmap.Overlays.list()
          for (const i in overlayList) {
            if (overlayList[i] instanceof longdo.Popup) {
              mmmap.Overlays.remove(overlayList[i])
            }
          }
        })

        this.configMap(mmmap)

        this.map = mmmap
        this.disableMapUI()
        this.$refs.MapBox.goCurrent()
      }

      if (scope.$route.name != 'LandmarkPoiList' && scope.$route.name != 'Place') {
        scope.map.Tags.clear()
      }

      // this.map.Overlays.clear()
      this.matchHeight()

      // Fix dvh bug in safari mobile
      if (navigator.userAgent.match(/(iPhone|iPad).*AppleWebKit.*Version/)) {
        this.$children[0].$refs.Sidebar.style.height = innerHeight + 'px'
      }
    },
    configMap(mmmap) {
      const mapLanguage = this.config.mapLocale || this.initialMapLanguage
      const mapLayer = this.config.map || this.initialMapLayer
      if (mapLanguage) {
        mmmap.language(mapLanguage)
        mmmap.Layers.setBase(mapLanguage === 'th' ? longdo.Layers.LIGHT_POI : longdo.Layers.LIGHT_POI_EN)
      }
      if (mapLayer) {
        if (mapLayer == longdo.Layers.TRAFFIC.name()) {
          mmmap.Layers.add(longdo.Layers.TRAFFIC)
          // mmmap.Overlays.load(longdo.Overlays.cameras)
          // mmmap.Overlays.load(longdo.Overlays.events)
        } else {
          mmmap.Layers.remove(longdo.Layers.TRAFFIC)
          mmmap.Overlays.unload(longdo.Overlays.cameras)
          mmmap.Overlays.unload(longdo.Overlays.events)
        }
      }
      this.initialMapLanguage = null
      this.initialMapLayer = null
    },
    disableMapUI () {
      let is_visible = false

      if (this.isDesktop()) {
        is_visible = true
      }

      delete this.map.Ui.popup
      this.map.Ui.DPad.visible(false)
      this.map.Ui.Zoombar.visible(false)
      this.map.Ui.Geolocation.visible(false)
      this.map.Ui.Toolbar.visible(is_visible)
      this.map.Ui.LayerSelector.visible(is_visible)
      this.map.Ui.Fullscreen.visible(is_visible)
      // this.map.Ui.Crosshair.visible(is_visible)
      // this.map.Ui.Legend.visible(is_visible)
      this.map.Ui.ContextMenu.enableNearPoi(is_visible)
      this.map.Ui.ContextMenu.enableAddress(is_visible)
    },
    convertToCurrency (fee, displayBaht = false) {
      if (isNaN(fee)) {
        return ''
      } else {
        var f1 = (fee).toFixed(0)
        var f2 = (fee).toFixed(1)
        if (fee + '' != f1) {
          return displayBaht ? `${f2} ${this.$i18n.messages[this.$i18n.locale].message.baht}` : `฿${f2}`
        } else if (f1 != 0) {
          return displayBaht ? `${f1} ${this.$i18n.messages[this.$i18n.locale].message.baht}` : `฿${f1}`
        }
      }

      return ''
    },
    focusPin (loca) {
      this.map.location({ lon: loca.lon, lat: loca.lat })
      return false
    },
    resize () {
      var scope = this
      clearTimeout(this.resizeDebounceTimer)
      this.resizeDebounceTimer = setTimeout(function () {
        const appContainer = document.getElementById('app');
        if (appContainer && window.visualViewport) {
          // Set the height of the container to the visual viewport height
          appContainer.style.height = `${window.visualViewport.height}px`;
        }
        scope.matchHeight()
      }, 200)
    },
    scrollTop(el, value) {
      if (value === undefined) {
        return el.pageYOffset;
      } else {
        if (el === window || el.nodeType === 9) {
          el.scrollTo(el.pageXOffset, value);
        } else {
          el.pageYOffset = value;
        }
      }
    },
    goBack (isPrevious) {
      this.active = false

      var redirect = localStorage.getItem('redirect')
      if (redirect != null) {
        isPrevious = true
      }

      if (isPrevious == undefined && !this.isDesktop()) {
        isPrevious = true
      }

      if (isPrevious) {
        this.$router.go(-1)
      } else {
        this.$router.replace("/")
      }
    },
    showMyLocation () {
      let scope = this
      scope.map.Overlays.list().forEach(pin => {
        if (pin.element() != null && pin.element().src == longdo.MapTheme.ui.geolocationMarkerIcon.urlHD) {
          scope.map.Overlays.remove(pin)
        }
      })
      if (scope.currentLocation == null) return

      scope.map.Overlays.add(new longdo.Marker(scope.currentLocation,
        {
          icon: longdo.MapTheme.ui.geolocationMarkerIcon,
          weight: longdo.OverlayWeight.Top,
        }))
    },
    showHideTags (tag) {
      let scope = this
      if (this.cache_landmark == null || this.cache_landmark == undefined) {
        this.cache_landmark = {}
      }
      this.cache_landmark.tag = tag
      // scope.map.Tags.clear()

      if (this.$route.path === '/landmarkpoi' || this.$route.path === '/place' || (this.$route.path === '/route' && tag.name == '__namtang_parking')) {
        scope.map.Tags.set(tag.name, {
          icon: {
            urlHD: scope.api_url + tag.pinImageUrlHD,
            offset: scope.getPinOffset('tag')
          },
        })
      }

      scope.map.Tags.enablePopup(false)
    },
    async getFavorites () {
      if (this.isNoLogin || !this.is_login) return
      // if (this.isNoLogin) return
      let scope = this

      // WS-110
      var url = process.env.API_URL + '/front/user/favorite/list'
      const apiResult = await this.Api.Call({
        method: 'GET',
        path: url,
      });
      if (apiResult.code === 200) {
        scope.favorite_results = apiResult.data
      }

      // WS-???
      var stopFavUrl = process.env.API_URL + '/front/user/stop-favorite/list'
      const topFavResult = await this.Api.Call({
        method: 'GET',
        path: stopFavUrl,
      });
      if (topFavResult.code === 200) {
        scope.stop_favorite_results = topFavResult.data
      }

      // this.hideLoading()
    },
    clearStopFavoritePins () {
      const scope = this
      this.map.Overlays.list().forEach(pin => {
        if (pin.stopFavorite) scope.map.Overlays.remove(pin)
      })
    },
    clearPlaceFavoritePins () {
      const scope = this
      this.map.Overlays.list().forEach(pin => {
        if (pin.favorite) scope.map.Overlays.remove(pin)
      })
    },
    // shared place-favorite (POI) pin drawing; pass a markerList to also track markers (Home uses
    // this for its list_marker click-detection)
    pinPlaceFavorite (markerList) {
      if (!this.map) return
      this.clearPlaceFavoritePins()
      const scope = this
      this.favorite_results.forEach(function (item) {
        var marker = new longdo.Marker(item.location, {
          title: item.name,
          icon: {
            urlHD: scope.icon.pin_fav,
            offset: scope.getPinOffset('favorite')
          },
          clickable: true
        })
        marker.favorite = JSON.stringify(item)
        scope.map.Overlays.add(marker)
        if (markerList) markerList.push(marker)
      })
    },
    isStopFavorite (stopId) {
      return this.stop_favorite_results.some(f => String(f.id) === String(stopId))
    },
    // remove any nearby/favorite stop pin for this id (NOT the enlarged selected pin)
    removeStopPin (stopId) {
      const scope = this
      const id = String(stopId)
      this.map.Overlays.list().forEach(pin => {
        if (pin.isStationSelected) return
        let pid = null
        if (pin.station) pid = JSON.parse(pin.station).id
        else if (pin.stopFavorite) pid = JSON.parse(pin.stopFavorite).id
        if (pid != null && String(pid) === id) scope.map.Overlays.remove(pin)
      })
    },
    // locally drop a favorite so the watcher redraws pins without refetching the list
    removeStopFavorite (stopId) {
      this.stop_favorite_results = this.stop_favorite_results.filter(f => String(f.id) !== String(stopId))
    },
    // locally add a favorite (favorite-shaped item) so the watcher redraws pins without refetching
    addStopFavorite (item) {
      if (!item || this.isStopFavorite(item.id)) return
      this.stop_favorite_results = [...this.stop_favorite_results, item]
    },
    pinStopFavorite () {
      if (!this.map) return
      this.clearStopFavoritePins()
      const scope = this
      const selectedId = String(this.$route.params.stationId == null ? '' : this.$route.params.stationId)
      this.stop_favorite_results.forEach(function (item) {
        if (String(item.id) === selectedId) return // selected (enlarged) pin wins
        // favorite wins over a plain nearby pin: drop any nearby pin for the same stop
        scope.map.Overlays.list().forEach(pin => {
          if (pin.station && String(JSON.parse(pin.station).id) === String(item.id)) scope.map.Overlays.remove(pin)
        })
        const title = scope.$i18n.locale === 'th' ? item.nameTh : item.nameEn
        var marker = new longdo.Marker(item.location, {
          title: title,
          icon: {
            urlHD: scope.api_url + item.pinImageUrlHD,
            offset: scope.getPinOffset(item.pinImageUrlHD, !!(item.largePinIcon))
          },
          clickable: true
        })
        marker.stopFavorite = JSON.stringify(item)
        scope.map.Overlays.add(marker)
      })
    },
    async getEvents () {
      let scope = this

      // WS-109
      var url = process.env.API_URL + '/front/events'
      url += '?locale=' + scope.getUILanguage()

      const apiResult = await this.Api.Call({
        method: 'GET',
        path: url,
      });

      if (apiResult.code === 200) {
        scope.event_results = apiResult.data
      }
    },
    getTags () {
      let scope = this

      // WS-108
      var url = process.env.API_URL + '/front/tags'
      url += `?locale=${scope.getUILanguage()}&platform=web`
      // this.showLoading()

      this.axios.get(url)
        .then(response => {
          if (response.status == 200 && response.data.code == 200) {
            scope.tag_results = response.data.data
            // scope.hideLoading()
          }
        })
        .catch(function (error) {
          // scope.hideLoading()
          console.log(error)
        })
    },
    getDisplacementDistance (loca1, loca2) {
      var distance = longdo.Util.distance([loca1, loca2])
      return distance
    },
    getPinOffset (url, selected = false) {
      if (url == "route_pin") {
        return { x: 33, y: 60 }
      }

      if (url == "tag") {
        return selected ? { x: 38, y: 70 } : { x: 16, y: 32 }
      }

      if (url == "destination_pin") {
        return { x: 25, y: 70 }
      }

      if (url == "favorite") {
        return { x: 16, y: 32 }
      }

      if (url == "event") {
        return { x: 13, y: 25 }
      }

      return selected ? { x: 38, y: 70 } : { x: 18.5, y: 36 }
    },
    notifyMe (msg) {
      // Let's check if the browser supports notifications
      if (!("Notification" in window)) {
        alert("This browser does not support desktop notification")
      }

      // Let's check whether notification permissions have already been granted
      else if (Notification.permission === "granted") {
        // If it's okay let's create a notification
        var notification = new Notification(msg)
      }

      // Otherwise, we need to ask the user for permission
      else if (Notification.permission !== "denied") {
        Notification.requestPermission().then(function (permission) {
          // If the user accepts, let's create a notification
          if (permission === "granted") {
            var notification = new Notification(msg)
          }
        })
      }

      // At last, if the user has denied notifications, and you
      // want to be respectful there is no need to bother them any more.
    },
    matchHeight () {
      var top_height = this.$refs.TopBox.$el.clientHeight

      if (this.isDesktop()) {
        this.$refs.MapBox.$refs.MapContentBox.style.paddingBottom = top_height + 'px'
      } else {
        var box = this.$refs.ContentBox.$refs.BottomBox
        if (box != undefined) {
          this.bottom_height = box.clientHeight
          this.$refs.MapBox.$refs.MapContentBox.style.paddingTop = '0px'
          this.$refs.MapBox.$refs.MapContentBox.style.paddingBottom = (this.bottom_height + top_height) + 'px'
          this.$refs.MapBox.$refs.ZoomBox.style.bottom = (this.bottom_height + 31) + 'px'
          // hide traffic-btn if there's not enough space
          const newsBoxHeight = document.querySelector('.latest-news-mobile')?.clientHeight || 0
          const zoomBoxBottom = (this.bottom_height + 31) + newsBoxHeight
          if (document.body.clientHeight - zoomBoxBottom < 275) {
            document.querySelector('.btn-traffic').style.display = 'none'
            document.querySelector('.zoom-box-container').style.display = 'none'
          } else {
            document.querySelector('.btn-traffic').style.display = 'block'
            document.querySelector('.zoom-box-container').style.display = 'block'
          }
        }
      }
      if (this.map != null) {
        this.map.resize()
        this.map.Ui.Fullscreen.visible(this.is_desktop)
      }
    },
    login (provider, user_id) {
      let scope = this

      var url = process.env.API_URL + '/authen/social'
      var config = {
        headers: {
          "Access-Control-Allow-Origin": "*",
          // "Access-Control-Allow-Methods": "GET, POST, PATCH, PUT, DELETE, OPTIONS",
          // "Access-Control-Allow-Headers": "Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With",
          'Content-type': 'application/x-www-form-urlencoded',
        },
      }

      this.axios.post(url, {
        provider: provider,
        user_id: user_id,
        access_token: scope.access_token
      })
        .then(response => {
          console.log(response)
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    mapBound (bound_list) {
      if (bound_list.length > 0) {
        var bound = longdo.Util.locationBound(bound_list)

        if (this.isDesktop()) {
          var beforeZoom = this.map.zoom()
          var pathMinLon = Math.min.apply(Math, bound_list.map(function (o) { return o.lon; }))
          var diff = (bound.maxLon - bound.minLon) / window.innerWidth;

          var width = 0
          if (document.getElementsByClassName('fixed-top').length > 0) {
            width += document.getElementsByClassName('fixed-top')[0].clientWidth
          } else if (document.getElementsByClassName('main-station').length > 0) {
            width += document.getElementsByClassName('main-station')[0].clientWidth
          }

          var spaceMinLonFromLeft = diff * width
          var pathMinLat = null
          bound_list.forEach(function (item, idx) {
            if (item.lon == pathMinLon) {
              pathMinLat = item.lat
            }
          })

          bound_list.push({ lon: pathMinLon - spaceMinLonFromLeft, lat: pathMinLat })
        }

        bound = longdo.Util.locationBound(bound_list)
        this.map.bound(bound)
        setTimeout(() => {
          this.map.zoom(this.map.zoom(), false)
        }, 100);
      }
    },
    getUILanguage () {
      try {
        var locale = this.$i18n.locale
        return locale
      }
      catch (ex) {
        if (this.$i18n != null) {

        }
        if (this.config.uiLocale == null) {
          var language = window.navigator.userLanguage || window.navigator.language;
          // console.log(language); //works IE/SAFARI/CHROME/FF
          return language.substring(0, 2)
        }

        return this.config.uiLocale
      }
    }
  }
}
</script>

<style lang="scss">
@import '../node_modules/bootstrap/scss/bootstrap.scss';
@import '../src/styles/custom.scss';
@import '../src/styles/loading.scss';
@import '../src/styles/sidenav.scss';
// @import '../src/styles/slideout.scss';
@import '../src/styles/timeline.scss';
@import '../src/styles/calendar.scss';

html,
body {
  height: 100dvh;
  flex: 1;
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100dvh;
  overflow: hidden;
  // position: fixed;

  .btn:focus, .btn.focus {
    box-shadow: none;
  }
}

#main {
  left: 0;
  width: -webkit-stretch;
  width: -moz-available;
  height: 100%;
}

@media (max-width: 768px) {
  #main {
    width: 100%;
  }
}

.container-fluid {
  // min-height: 100%;
  height: 100%;
}

.wrapper,
.viewer {
  height: 100%;
}

.navbar {
  width: 100%;
  padding: 12px !important;
  z-index: 998;
  background: transparent;
  position: absolute;
  &.navbar-desktop {
    padding: 15px 10px !important;
    background: rgba(var(--vs-primary),1);
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.14);
    position: relative;
  }
}

#suggest,
#suggestDestination {
  position: absolute;
  width: 100%;
  padding: 10px;
  border: 1px solid #cccccc;
  border-top: none;
  background: white;
  text-align: initial;
  z-index: 1;
}

.box-round {
  color: rgba(var(--vs-primary),1);
  box-shadow: 2px 4px 6px rgba(106, 106, 106, 0.02);
  border-radius: 8px;
  padding: 6px 14px;
}

.fullname {
  font-size: 16px;
}

.email {
  font-size: 14px;
}

.config {
  right: unset;
  width: auto;
  // position: absolute;
  border-top: 1px solid #ccc;
}

@media (min-width: 1024px) {
  .config {
    border: none;
  }
}
</style>
